import * as React from "react";
import { Link } from "react-router-dom";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import ILicenseKeySearchResult from "../../types/ILicenseKeySearchResults";

interface ILicenseKeyRowProps extends ITranslationProps, ILicenseKeySearchResult {
}

class LicenseKeyRow extends React.Component<ILicenseKeyRowProps> {
    constructor(props: ILicenseKeyRowProps) {
        super(props);
    }

    public render() {
        return (
            <tr>
                <td><Link to={`/licenseKey/${this.props.id}`} title={`Open ${this.props.keyName}`}>{this.props.keyName}</Link></td>
                <td>{this.props.licenseKey}</td>
                <td>{this.props.isActive ? this.props.t("Global.Active") : this.props.t("Global.Inactive")}</td>
            </tr>
        );
    }
}

export default translateComponent(LicenseKeyRow);



// WEBPACK FOOTER //
// ./src/components/LicenseKeyList/LicenseKeyRow.tsx